export default __webpack_public_path__ + "static/char-17-d6a530f9c952995df03ee9aa585849fb.webp";